/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerStartOrgTransferMutationRequest, TransfersControllerStartOrgTransferMutationResponse, TransfersControllerStartOrgTransferPathParams, TransfersControllerStartOrgTransfer400, TransfersControllerStartOrgTransfer401, TransfersControllerStartOrgTransfer403 } from "../../models/transfersController/TransfersControllerStartOrgTransfer";

function getTransfersControllerStartOrgTransferUrl(organizationId: TransfersControllerStartOrgTransferPathParams["organizationId"]) {
  const res = { method: 'POST', url: `/api/v1/transfers/organization/${organizationId}` as const }  
  return res
}

/**
 * @summary Start a transfer for an organization
 * {@link /api/v1/transfers/organization/:organizationId}
 */
export async function transfersControllerStartOrgTransfer(organizationId: TransfersControllerStartOrgTransferPathParams["organizationId"], data?: TransfersControllerStartOrgTransferMutationRequest, config: Partial<RequestConfig<TransfersControllerStartOrgTransferMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransfersControllerStartOrgTransferMutationResponse, ResponseErrorConfig<TransfersControllerStartOrgTransfer400 | TransfersControllerStartOrgTransfer401 | TransfersControllerStartOrgTransfer403>, TransfersControllerStartOrgTransferMutationRequest>({ method : "POST", url : getTransfersControllerStartOrgTransferUrl(organizationId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}